import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn, thStyle } from './ReportShell';

function PartyandItemWiseReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, username, logout, branchstate } = useAuth();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    // Customer

    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [selectedCustomers, setCustomerType] = useState("0");

    const fetchCustomerType = async () => {
        try {

            const response = await fetchData('ReportApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(cmr => ({
                    value: cmr.MasterId,
                    label: cmr.Name
                }));
                setCustomerTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Raw Type:', error);
        }
    };
    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setCustomerType(selectedOption.value);
    };

    useEffect(() => {
        fetchCustomerType();
    }, []);
    // Item

    const [ItemTypeOptions, setItemTypeOptions] = useState([]);
    const [selectedItemType, setSelectedItemType] = useState("");
    const [selectedItem, setSelectedItem] = useState("0");

    const fetchItemType = async () => {
        try {

            const response = await fetchData('ItemApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(itm => ({
                    value: itm.id,
                    label: itm.name
                }));
                setItemTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Item Type:', error);
        }
    };
    const handleItemTypeChange = (selectedOption) => {
        setSelectedItemType(selectedOption);
        setSelectedItem(selectedOption.value);
    };

    useEffect(() => {
        fetchItemType();
    }, []);

    const fetchTableData = async () => {
        setDataItem([])
        try {

            if (PartyandItemWise === "1") {

                const response = await fetchData('ReportApi', `/SalePartyWise/${companyId}/${selectedCustomers}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
            else if (PartyandItemWise === "2") {
                const response = await fetchData('ReportApi', `/SaleItemWise/${companyId}/${selectedItem}/${fromDate}/${toDate}`, token);

                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }

    };
    const [PartyandItemWise, setPartyandItemWise] = useState("1");
    const handlesetPartyandItemWiseChange = (event) => {
        setPartyandItemWise(event.target.value);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    const columnsCustomerWise = [
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Item Name" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];

    // const handleExportCustomerWiseExcel = () => {
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     // Function to add headers to the worksheet
    //     const addExcelHeader = (worksheet, title, columns) => {
    //         worksheet.push([`${title} | Generated On: ${formattedDateTime} By : ${username}`]);
    //         worksheet.push([]); // Empty row
    //         worksheet.push(columns.map((col) => col.label)); // Add column headers
    //     };

    //     // Function to prepare customer-wise data
    //     const exportCustomerWiseData = () => {
    //         const customerWiseSheet = [];
    //         const columns = columnsCustomerWise;

    //         addExcelHeader(customerWiseSheet, 'Customer Wise Data', columns);

    //         let previousCustomer = null;

    //         filteredDataItem.forEach((row) => {
    //             if (row.MasterName !== previousCustomer) {
    //                 customerWiseSheet.push([`Customer: ${row.MasterName}`]);
    //                 previousCustomer = row.MasterName;
    //             }

    //             customerWiseSheet.push([
    //                 row.BillDate,
    //                 row.BillNumber,
    //                 row.ItemName,
    //                 row.Quantity,
    //                 row.Rate.toFixed(2),
    //                 row.TaxableAmount.toFixed(2),
    //                 `${row.GSTRate}%`,
    //                 row.GSTAmount.toFixed(2),
    //                 row.TotalAmount.toFixed(2),
    //             ]);
    //         });

    //         customerWiseSheet.push([]); // Add an empty row at the end
    //         return customerWiseSheet;
    //     };

    //     // Generate customer-wise Excel data
    //     console.log("Exporting Customer Wise Data...");
    //     const customerWiseSheetData = exportCustomerWiseData();
    //     const wb = XLSX.utils.book_new();
    //     const customerSheet = XLSX.utils.aoa_to_sheet(customerWiseSheetData);

    //     XLSX.utils.book_append_sheet(wb, customerSheet, 'Customer Wise Report');
    //     XLSX.writeFile(wb, 'Customer_Wise_Report.xlsx');
    // };


    const handleExportCustomerWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Customer Wise Report');

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        // 🔹 BORDER STYLE
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER (Merged & Centered)
        worksheet.mergeCells('A1:I1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `CustomerWise Sale Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.addRow([]);
        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Bill Date',
            'Bill No',
            'Item Name',
            'Quantity',
            'Rate',
            'Taxable Amount',
            'GST Rate',
            'GST Amount',
            'Total Amount'
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
            cell.border = thinBorder;
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        });

        // 🔹 DATA SECTION
        let previousCustomer = null;

        filteredDataItem.forEach((rowData) => {
            // Add Customer Header Row
            if (rowData.MasterName !== previousCustomer) {
                const customerRow = worksheet.addRow([`Customer: ${rowData.MasterName}`]);
                customerRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                customerRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4F81BD' }, // Blue header for customer
                };
                customerRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                worksheet.mergeCells(`A${customerRow.number}:I${customerRow.number}`);
                previousCustomer = rowData.MasterName;
            }

            // Add Item Row
            const dataRow = worksheet.addRow([
                rowData.BillDate,
                rowData.BillNumber,
                rowData.ItemName,
                rowData.Quantity,
                rowData.Rate?.toFixed(2),
                rowData.TaxableAmount?.toFixed(2),
                `${rowData.GSTRate}%`,
                rowData.GSTAmount?.toFixed(2),
                rowData.TotalAmount?.toFixed(2),
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;

                if (colNumber >= 4) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });
        });

        // 🔹 COLUMN WIDTHS
        worksheet.columns = [
            { width: 14 }, // Bill Date
            { width: 12 }, // Bill No
            { width: 25 }, // Item Name
            { width: 10 }, // Quantity
            { width: 12 }, // Rate
            { width: 15 }, // Taxable
            { width: 10 }, // GST Rate
            { width: 12 }, // GST Amount
            { width: 15 }, // Total
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Customer_Wise_Report_${formattedDateTime.replace(/[/: ]/g, '_')}.xlsx`);
    };


    const columnsItemWise = [
        { label: "Item Name" },
        { label: "Customer Name" },
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];



    const handleExportItemWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Item Wise Report');

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        // 🔹 BORDER STYLE
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER (Merged & Centered)
        worksheet.mergeCells('A1:J1');
       const headerCell = worksheet.getCell('A1');
        headerCell.value = `ItemWise Sale Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Item Name',
            'Customer Name',
            'Bill Date',
            'Bill No',
            'Quantity',
            'Rate',
            'Taxable Amount',
            'GST Rate',
            'GST Amount',
            'Total Amount'
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'BADFDB' }, // Light green (header)
            };
            cell.border = thinBorder;
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        });

        // 🔹 DATA SECTION
        let previousItem = null;

        filteredDataItem.forEach((rowData) => {
            // Add Light Blue Item Header Row
            if (rowData.ItemName !== previousItem) {
                const itemRow = worksheet.addRow([`Item: ${rowData.ItemName}`]);
                itemRow.getCell(1).font = { bold: true, color: { argb: 'FF000000' } }; // Black text
                itemRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'F5F5F0' }, // 🔹 Light blue background
                };
                itemRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                worksheet.mergeCells(`A${itemRow.number}:J${itemRow.number}`);
                previousItem = rowData.ItemName;
            }

            // Add Data Row
            const dataRow = worksheet.addRow([
                rowData.ItemName,
                rowData.MasterName,
                rowData.BillDate,
                rowData.BillNumber,
                rowData.Quantity,
                rowData.Rate?.toFixed(2),
                rowData.TaxableAmount?.toFixed(2),
                `${rowData.GSTRate}%`,
                rowData.GSTAmount?.toFixed(2),
                rowData.TotalAmount?.toFixed(2),
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;
                if (colNumber >= 5) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });
        });

        // 🔹 COLUMN WIDTHS
        worksheet.columns = [
            { width: 25 }, // Item Name
            { width: 25 }, // Customer Name
            { width: 14 }, // Bill Date
            { width: 12 }, // Bill No
            { width: 10 }, // Quantity
            { width: 12 }, // Rate
            { width: 15 }, // Taxable
            { width: 10 }, // GST Rate
            { width: 12 }, // GST Amount
            { width: 15 }, // Total
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Item_Wise_Report_${formattedDateTime.replace(/[/: ]/g, '_')}.xlsx`);
    };


    const cellStyle = {
        borderBottom: '1px solid #ddd',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };


    const amountCols = ['Quantity','Rate','Taxable Amount','GST Rate','GST Amount','Total Amount'];

    return (
        <ReportShell
            title="SALES PARTY & ITEM WISE"
            recordCount={filteredDataItem.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
                {[['1','Party Wise','#2563eb'],['2','Item Wise','#92400e']].map(([val, label, color]) => (
                    <label key={val} style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                        <input type="radio" name="piWise" value={val} checked={PartyandItemWise === val} onChange={handlesetPartyandItemWiseChange} />
                        <span style={{ color }}>{label}</span>
                    </label>
                ))}
                {PartyandItemWise === '1' && (
                    <div style={{ minWidth: 180 }}>
                        <Select value={selectedCustomerType} onChange={handleCustomerTypeChange} options={CustomerTypeOptions} placeholder="Customer" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }) }} />
                    </div>
                )}
                {PartyandItemWise === '2' && (
                    <div style={{ minWidth: 180 }}>
                        <Select value={selectedItemType} onChange={handleItemTypeChange} options={ItemTypeOptions} placeholder="Item" isSearchable menuPortalTarget={document.body} styles={{ control: (b) => ({ ...b, minHeight: 28, height: 28, fontSize: 12 }), valueContainer: (b) => ({ ...b, height: 28, padding: '0 6px' }), indicatorsContainer: (b) => ({ ...b, height: 28 }), menuPortal: (b) => ({ ...b, zIndex: 2000 }) }} />
                    </div>
                )}
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={PartyandItemWise === '1' ? handleExportCustomerWiseExcel : handleExportItemWiseExcel} style={excelBtn}>Excel</button>
            </>}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {(PartyandItemWise === '1'
                                ? ['Bill Date','Bill Number','Item Name','Quantity','Rate','Taxable Amount','GST Rate','GST Amount','Total Amount']
                                : ['Item Name','Customer Name','Bill Date','Bill Number','Quantity','Rate','Taxable Amount','GST Rate','GST Amount','Total Amount']
                            ).map((col) => (
                                <TableCell key={col} style={{ ...thStyle, textAlign: amountCols.includes(col) ? 'right' : 'left' }}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {PartyandItemWise === '1' ? (
                            Object.entries(filteredDataItem.reduce((acc, item) => { if (!acc[item.MasterName]) acc[item.MasterName] = []; acc[item.MasterName].push(item); return acc; }, {})).map(([customerName, items], ci) => (
                                <React.Fragment key={ci}>
                                    <TableRow sx={{ backgroundColor: 'rgba(45,212,191,0.08)' }}>
                                        <TableCell colSpan={9} sx={{ fontWeight: 700, fontSize: '11px', color: '#14b8a6', padding: '4px 8px' }}>{customerName}</TableCell>
                                    </TableRow>
                                    {items.map((data, index) => (
                                        <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? '#fdfdfd' : '#f7fdfc', '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' } }}>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{formatDate(data.BillDate)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.BillNumber}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.ItemName}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.Quantity}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.Rate?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.TaxableAmount?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.GSTRate}%</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.GSTAmount?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.TotalAmount?.toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow sx={{ backgroundColor: '#f0f4f4' }}>
                                        <TableCell colSpan={3} sx={{ fontWeight: 700, padding: '4px 8px', fontSize: '12px' }}>Subtotal</TableCell>
                                        <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '4px 8px', fontSize: '12px' }}>{items.reduce((s, i) => s + Number(i.Quantity || 0), 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '4px 8px', fontSize: '12px' }}>{items.reduce((s, i) => s + Number(i.Rate || 0), 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '4px 8px', fontSize: '12px' }}>{items.reduce((s, i) => s + Number(i.TaxableAmount || 0), 0).toFixed(2)}</TableCell>
                                        <TableCell />
                                        <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '4px 8px', fontSize: '12px' }}>{items.reduce((s, i) => s + Number(i.GSTAmount || 0), 0).toFixed(2)}</TableCell>
                                        <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '4px 8px', fontSize: '12px' }}>{items.reduce((s, i) => s + Number(i.TotalAmount || 0), 0).toFixed(2)}</TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))
                        ) : (
                            Object.entries(filteredDataItem.reduce((acc, item) => { if (!acc[item.ItemName]) acc[item.ItemName] = []; acc[item.ItemName].push(item); return acc; }, {})).map(([itemName, items], ii) => (
                                <React.Fragment key={ii}>
                                    <TableRow sx={{ backgroundColor: 'rgba(45,212,191,0.08)' }}>
                                        <TableCell colSpan={10} sx={{ fontWeight: 700, fontSize: '11px', color: '#14b8a6', padding: '4px 8px' }}>{itemName}</TableCell>
                                    </TableRow>
                                    {items.map((data, index) => (
                                        <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? '#fdfdfd' : '#f7fdfc', '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' } }}>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.ItemName}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.MasterName}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{formatDate(data.BillDate)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{data.BillNumber}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.Quantity}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.Rate?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.TaxableAmount?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.GSTRate}%</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.GSTAmount?.toFixed(2)}</TableCell>
                                            <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{data.TotalAmount?.toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </ReportShell>
    );
}

export default PartyandItemWiseReport;
